import { Group, Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { TitleCard } from '@/core/components';

import { Discipline } from './../../model/DisciplineTypes';
import classes from './DisciplineCard.module.css';

export interface DisciplineCardProps {
  discipline: Discipline;
  to: string;
}

export function DisciplineCard({ discipline, to }: DisciplineCardProps) {
  const { name, department } = discipline;

  return (
    <Paper
      className={classes.card}
      component={Link}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="12px">
        <TitleCard title={name} />

        <Group>
          <Text
            c="dimmed"
            size="sm"
          >
            {department.name}
          </Text>
        </Group>
      </Stack>
    </Paper>
  );
}
